
import Vue from 'vue'

export default Vue.extend({
   name: 'ContactInputSummary',
   data() {
      return {
         step: 'information',
      }
   },
   computed: {
      visible(): boolean {
         return (
            this.$store.state.step !== this.step &&
            this.$store.state.viewedSteps.includes(this.step)
         )
      },
      name(): string {
         return this.$store.getters.partyName
      },
      username(): string {
         return this.$store.getters.username
      },
   },
   methods: {
      change() {
         this.$store.commit('setStep', this.step)
      },
   },
})
